import script from "./editUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./editUserForm.vue?vue&type=script&setup=true&lang=js"

import "./editUserForm.vue?vue&type=style&index=0&id=5a975073&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a975073"]])

export default __exports__